import React, { Component } from 'react';
import { connect } from 'react-redux';
import Service from '../../services';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { BoardsIconInActive, GradesIcon } from '../svgIcons';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import { getBoardsData, getBranchesLatest } from '../../store/actions';
import { userAssignedBoards } from '../../store/selectors/userAssignedBoards';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import { cloneDeep } from 'lodash';

class BranchToSectionMultiDDTillSec extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boardIds: null,
            classIds: null,
            groupId: null,
            branchIds: null,
            sectionIds: null,
            boards: [],
            classes: [],
            sections: [],
            curriculumInfo: {}
        };
        this.service = new Service();
    }

    componentDidMount() {
        this.getData();
    }


    componentDidUpdate(prevProps, prevState) {
        // Check if dropdownsData prop has changed (for edit mode)
        const hasDropdownDataChanged =
            this.props.dropdownsData &&
            prevProps.dropdownsData &&
            JSON.stringify(this.props.dropdownsData) !== JSON.stringify(prevProps.dropdownsData);

        // Check if we need to update from props
        const shouldUpdateFromProps =
            (this.state.branchIds == null || hasDropdownDataChanged) &&
            this.props.boards && this.props.boards.length > 0 &&
            this.props.branchData && this.props.branchData.length > 0 &&
            this.props.dropdownsData !== undefined &&
            this.props.dropdownsData !== null;

        if (shouldUpdateFromProps) {
            const { branchIds, boardIds, classIds, sectionIds } = this.props.dropdownsData;

            console.log('[BranchToSectionMultiDDTillSec] componentDidUpdate - Received dropdownsData:', {
                branchIds,
                boardIds,
                classIds,
                sectionIds,
                hasData: branchIds && branchIds.length > 0
            });

            // Only proceed if we have valid data
            if (!branchIds || branchIds.length === 0) {
                console.log('[BranchToSectionMultiDDTillSec] No branch IDs provided, skipping update');
                return;
            }

            let branchdIds = branchIds;

            // Filter boards based on user role and selected branches
            let filteredBoards = this.getFilteredBoards(branchdIds);

            console.log('[BranchToSectionMultiDDTillSec] Filtered boards:', filteredBoards);

            if (filteredBoards.length > 0) {
                let filterClasses = filteredBoards
                    ?.filter((board) => boardIds?.includes(board.boardId))
                    ?.map((e) => e.classes)
                    .flat();

                // Remove duplicate classes
                filterClasses = this.removeDuplicates(filterClasses, 'classId');

                // Filter sections properly based on selected branches, boards, and classes
                let filteredSections = [];
                
                classIds?.forEach(classId => {
                    const selectedClass = filterClasses?.find(cls => cls.classId === classId);
                    
                    if (selectedClass && selectedClass.sections) {
                        const validSections = selectedClass.sections.filter(sec => {
                            // Check if section belongs to selected branch
                            const belongsToSelectedBranch = branchdIds?.includes(sec?.branchId);

                            // Check if section is from the selected board
                            const isFromSelectedBoard = boardIds?.some(boardId => {
                                const board = filteredBoards.find(b => b.boardId === boardId);
                                if (!board) return false;

                                // Verify this board:
                                // 1. Is assigned to the section's branch
                                // 2. Contains this specific class
                                // 3. Contains this specific section
                                const isBoardAssignedToBranch = board.assignedBranches?.includes(sec?.branchId);
                                const boardHasThisClass = board.classes?.some(cls => cls.classId === classId);
                                const boardHasThisSection = board.classes?.some(cls =>
                                    cls.classId === classId &&
                                    cls.sections?.some(s => s.sectionId === sec.sectionId)
                                );

                                return isBoardAssignedToBranch && boardHasThisClass && boardHasThisSection;
                            });

                            return belongsToSelectedBranch && isFromSelectedBoard;
                        });

                        filteredSections.push(...validSections);
                    }
                });

                // Apply user role-based section filtering
                filteredSections = this.getFilteredSections(filteredSections);

                // Only keep section IDs that are in the filtered sections
                const validSectionIds = filteredSections.map(sec => sec.sectionId);
                const validatedSectionIds = sectionIds?.filter(id => validSectionIds.includes(id)) || [];

                console.log('[BranchToSectionMultiDDTillSec] Setting state with:', {
                    branchIds: branchdIds,
                    boardIds: boardIds,
                    classIds: classIds,
                    sectionIds: validatedSectionIds,
                    boardsCount: filteredBoards.length,
                    classesCount: filterClasses.length,
                    sectionsCount: filteredSections.length,
                    originalSectionIds: sectionIds?.length,
                    validatedSectionIds: validatedSectionIds.length
                });

                this.setState({
                    branchIds: branchdIds,
                    boards: filteredBoards,
                    boardIds: boardIds,
                    classes: filterClasses,
                    classIds: classIds,
                    sectionIds: validatedSectionIds,
                    sections: filteredSections
                });
            } else {
                console.log('[BranchToSectionMultiDDTillSec] No filtered boards found');
            }
        }
    }

    getData = () => {
        /* this.props.getBranchesLatest();
        this.props.getBoardsData(true); */
    };

    // Helper method to check if user is a teacher
    isTeacher = () => {
        // Check user type from localStorage
        const userType = localStorage.getItem('type');

        // Only if type is 'teacher', check for assignedSubjects
        if (userType === 'teacher') {
            return this.props.userInfo?.assignedSubjects && this.props.userInfo.assignedSubjects.length > 0;
        }

        // For all other types (admin, staff, etc.), return false (they get all sections)
        return false;
    }

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];

        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    // Filter branches based on user's assigned branches
    getFilteredBranches = () => {
        const { userInfo, branchData } = this.props;

        // If user is admin, return all branches
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        // For non-admin users, filter by assigned branches
        if (!userInfo.branchs || userInfo.branchs.length === 0) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        const filtered = branchData.filter(branch =>
            userInfo.branchs.includes(branch.key)
        );

        return this.removeDuplicates(filtered, 'key');
    }

    // Filter boards based on user's assigned branches and boards
    getFilteredBoards = (selectedBranchIds) => {
        const { userInfo, boards } = this.props;

        let filteredBoards = cloneDeep(boards || []);

        // Filter by selected branches
        if (selectedBranchIds && selectedBranchIds.length > 0) {
            filteredBoards = filteredBoards.filter(board =>
                board.assignedBranches.some(branchId => selectedBranchIds.includes(branchId))
            );
        }

        // If user is admin, return boards filtered only by selected branches
        if (userInfo?.isAdmin === true) {
            // Remove duplicate boards by boardId
            filteredBoards = this.removeDuplicates(filteredBoards, 'boardId');
        } else {
            // For teachers, additionally filter by assigned boards
            if (this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    userInfo?.boardId.includes(board.boardId)
                );
            }
            // For non-admin, non-teacher users, filter by assigned boards if available
            else if (!this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    userInfo?.boardId.includes(board.boardId)
                );
            }

            // Remove duplicate boards by boardId
            filteredBoards = this.removeDuplicates(filteredBoards, 'boardId');
        }

        // Add display names
        filteredBoards.forEach((board) => {
            // Remove duplicate classes
            board.classes = this.removeDuplicates(board.classes, 'classId');

            board?.classes?.forEach((classs) => {
                classs.className = board?.boardName + ' -- ' + classs.className;
                classs.sections.forEach((sec) => (sec.sectionName = classs.className + ' -- ' + sec.sectionName));
            });
        });

        return filteredBoards;
    }

    // Filter sections based on user role and assigned sections
    getFilteredSections = (sections) => {
        const { userInfo } = this.props;

        // If user is admin, return all sections
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(sections || [], 'sectionId');
        }

        // For teachers, filter by assigned sections
        if (this.isTeacher()) {
            // If teacher has no assigned sections, return empty array
            if (!userInfo?.sections || userInfo.sections.length === 0) {
                return [];
            }

            const filtered = sections.filter(section =>
                userInfo.sections.includes(section.sectionId)
            );
            return this.removeDuplicates(filtered, 'sectionId');
        }

        // For non-teacher users, return all sections
        return this.removeDuplicates(sections || [], 'sectionId');
    }

    onChangeBranch = (branchIds) => {
        this.setState({
            boards: [],
            classes: [],
            sections: []
        });

        // Filter boards based on user role and selected branches
        let filteredBoards = this.getFilteredBoards(branchIds);

        this.setState(
            {
                branchIds: branchIds,
                boards: filteredBoards,
                classes: [],
                boardIds: '',
                classIds: '',
                branches: [],
                sections: [],
                sectionIds: []
            }
        );
    };

    onChangeBoard = (boardIds) => {
        this.setState({
            classes: [],
            sections: []
        });

        let filteredClasses = [];

        this.state.boards.forEach((board) => {
            if (boardIds.includes(board.boardId)) {
                filteredClasses.push(...board.classes);
            }
        });

        // Remove duplicate classes by classId
        filteredClasses = this.removeDuplicates(filteredClasses, 'classId');

        this.setState(
            {
                classes: filteredClasses,
                boardIds,
                classIds: '',
                branches: [],
                sections: [],
                sectionIds: []
            }
        );
    };

    onChangeClass = (classIds) => {
        console.log('[onChangeClass] Called with classIds:', classIds);
        console.log('[onChangeClass] Current state:', {
            branchIds: this.state.branchIds,
            boardIds: this.state.boardIds,
            availableClasses: this.state.classes.length
        });

        let lsecs = []

        // For each selected class ID
        classIds?.forEach(classId => {
            // Find the class in the current classes
            const selectedClass = this.state.classes?.find(cls => cls.classId === classId);
            
            console.log('[onChangeClass] Processing classId:', classId, 'Found class:', selectedClass?.className);

            if (selectedClass && selectedClass.sections) {
                console.log('[onChangeClass] Total sections in class:', selectedClass.sections.length);
                
                // Filter sections for this specific class
                const validSections = selectedClass.sections.filter(sec => {
                    // Check if section belongs to selected branch
                    const belongsToSelectedBranch = this.state.branchIds?.includes(sec?.branchId);

                    // Check if section is from the selected board
                    const isFromSelectedBoard = this.state.boardIds?.some(boardId => {
                        const board = this.state.boards.find(b => b.boardId === boardId);
                        if (!board) return false;

                        // Verify this board:
                        // 1. Is assigned to the section's branch
                        // 2. Contains this specific class
                        // 3. Contains this specific section
                        const isBoardAssignedToBranch = board.assignedBranches?.includes(sec?.branchId);
                        const boardHasThisClass = board.classes?.some(cls => cls.classId === classId);
                        const boardHasThisSection = board.classes?.some(cls =>
                            cls.classId === classId &&
                            cls.sections?.some(s => s.sectionId === sec.sectionId)
                        );

                        const isValid = isBoardAssignedToBranch && boardHasThisClass && boardHasThisSection;
                        
                        if (!isValid) {
                            console.log('[onChangeClass] Section filtered out:', sec.sectionName, {
                                belongsToBranch: isBoardAssignedToBranch,
                                hasClass: boardHasThisClass,
                                hasSection: boardHasThisSection
                            });
                        }
                        
                        return isValid;
                    });

                    const finalValid = belongsToSelectedBranch && isFromSelectedBoard;
                    
                    if (!finalValid) {
                        console.log('[onChangeClass] Section REJECTED:', sec.sectionName, {
                            belongsToSelectedBranch,
                            isFromSelectedBoard
                        });
                    }
                    
                    return finalValid;
                });

                console.log('[onChangeClass] Valid sections for class:', validSections.length);
                lsecs.push(...validSections);
            }
        });

        // Apply teacher-specific filtering to sections
        lsecs = this.getFilteredSections(lsecs);

        console.log('[onChangeClass] Final filtered sections:', lsecs.length, lsecs.map(s => ({
            id: s.sectionId,
            name: s.sectionName,
            branchId: s.branchId
        })));

        // Preserve only valid section selections
        const validSectionIds = lsecs.map(sec => sec.sectionId);
        const preservedSectionIds = this.state.sectionIds?.filter(id => validSectionIds.includes(id)) || [];

        this.setState(
            {
                classIds: classIds,
                sections: lsecs,
                sectionIds: preservedSectionIds
            },
            () => {
                console.log('[onChangeClass] State updated - sections in state:', this.state.sections.length);
                console.log('[onChangeClass] Sections:', this.state.sections.map(s => s.sectionName));
                // Only call setDropdownsData if we have valid sections selected
                if (preservedSectionIds.length > 0) {
                    this.setDropdownsData();
                }
            }
        );
    };

    onChangeSection = (sectionIds) => {
        this.setState(
            {
                sectionIds: sectionIds
            },
            () => this.setDropdownsData()
        );
    };

    setDropdownsData = () => {
        let { boardIds, classIds, branchIds, sectionIds } = this.state;
        let branchNames = [];
        let boardNames = [];
        let gradeNames = [];
        let sectionNames = [];

        if (sectionIds?.length) {
            branchNames = branchIds?.map((e) => this.props.branchData?.find((f) => e == f.key)?.name || '');
            boardNames = boardIds?.map((e) => this.state?.boards?.find((f) => e == f.boardId)?.boardName || '');
            gradeNames = classIds?.map((e) => this.state?.classes?.find((f) => e == f.classId)?.className || '');
            sectionNames = sectionIds?.map((e) => this.state?.sections?.find((f) => e == f.sectionId)?.sectionName || '');
        }

        this.props.setValues({
            boardIds,
            classIds,
            branchIds,
            sectionIds,
            branchNames,
            boardNames,
            gradeNames,
            sectionNames
        });
    };

    render() {
        // Get filtered branches for dropdown
        const filteredBranchData = this.getFilteredBranches();

        return (
            <div>
                <div>
                    <div className="grid -m-1">
                        <div className=" col-6">
                            <ClassetMultiSelect
                                required={true}
                                label={'Branch'}
                                icon={<BoardsIconInActive height={16.5} width={19.5} />}
                                placeholder={'Select Branch'}
                                options={filteredBranchData}
                                width={'445px'}
                                value={this.state.branchIds}
                                onChange={(e) => this.onChangeBranch(e.value)}
                                optionLabel="name"
                                optionValue="key"
                            />
                        </div>
                        <div className=" col-6">
                            <ClassetMultiSelect
                                width={'445px'}
                                required={true}
                                label={'Board'}
                                icon={<BoardsIconInActive height={16.5} width={19.5} />}
                                placeholder={'Select Board'}
                                options={this.state.boards}
                                value={this.state.boardIds}
                                onChange={(e) => this.onChangeBoard(e.value)}
                                optionLabel="boardName"
                                optionValue="boardId"
                            />
                        </div>
                        <div className=" col-6">
                            <ClassetMultiSelect
                                width={'445px'}
                                label={'Grade'}
                                required={true}
                                icon={<GradesIcon />}
                                placeholder={'Select (Board - Grade)'}
                                options={this.state?.classes}
                                value={this.state.classIds}
                                onChange={(e) => this.onChangeClass(e.value)}
                                optionLabel="className"
                                optionValue="classId"
                            />
                        </div>
                        <div className=" col-6">
                            <ClassetMultiSelect
                                width={'445px'}
                                required={true}
                                label={'Section'}
                                icon={<GradesIcon />}
                                placeholder={'Select (Board - Grade - Section)'}
                                options={this.state?.sections}
                                value={this.state.sectionIds}
                                onChange={(e) => this.onChangeSection(e.value)}
                                optionLabel="sectionName"
                                optionValue="sectionId"
                            />
                        </div>
                    </div>
                </div>
                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
                {this.state.isLoading && (
                    <>
                        <LoadingComponent />
                    </>
                )}
            </div>
        );
    }
}

const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {}
});
export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(BranchToSectionMultiDDTillSec);
